import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[fileTypeImage]',
})
export class FileTypeImageDirective implements OnChanges {
    @Input() fileName: string | undefined;
    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['fileName'] && this.fileName) {
            this.updateImage();
        }
    }

    private updateImage() {
        const fileName = this.fileName.slice(this.fileName.lastIndexOf('.') + 1);

        let className = '';
        if (fileName?.toLowerCase().includes('xls')) {
            className = 'excel-icon';
        } else if (fileName.toLowerCase().includes('pdf')) {
            className = 'pdf-icon';
        }

        this.renderer.addClass(this.el.nativeElement, className);
    }
}
